import { withStyles } from '@material-ui/core/styles';
import { RISK_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/risk-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(ListForm({ service, title: RISK_LIST_TITLE, name: 'RISK' }));
